import { i18n } from '@/i18n'

export default [
  {
    path: 'certificates',
    name: 'certificates',
    component: () => import('@/views/certificates/Certificates.vue'),
    meta: { registerNavFromMenu: true, title: i18n.t('app.certificates') }
  },
  {
    path: 'certificates/:idEmpresa/:serial/:tipo/details',
    name: 'certificates/detail',
    component: () => import('@/views/certificates/Certificate.vue'),
    meta: { secondaryMenu: 'certificates', registerNavFromMenu: false, title: i18n.t('app.certificate_detail') }
  },
  {
    path: 'certificates/:idEmpresa/:serial/:tipo/companies',
    name: 'certificates/companies',
    component: () => import('@/views/certificates/Companies.vue'),
    meta: { secondaryMenu: 'certificates', registerNavFromMenu: false, title: i18n.t('app.companies_link') }
  },
  {
    path: 'certificates/:idEmpresa/:serial/:tipo/historical',
    name: 'certificates/historical',
    component: () => import('@/views/historical/CertificateHistorical.vue'),
    meta: { secondaryMenu: 'certificates', registerNavFromMenu: false, title: i18n.t('historical.by_certificate') }
  },
  {
    path: 'certificates/:idEmpresa/:serial/:tipo/replace',
    name: 'certificates/replace',
    component: () => import('@/views/certificates/ReplaceCertificate.vue'),
    meta: { secondaryMenu: 'replacecertificate', registerNavFromMenu: false, title: i18n.t('certificates.detail_replace') }
  }
]
